import { useMutation } from '@apollo/client';
import { VIEW_FRONT_SPOT_DETAIL_FAQS } from '../../graphql/user-mutations';

export default function useMutateViewSpotDetailFaqs() {
    const [viewSpotDetailFaqs] = useMutation(VIEW_FRONT_SPOT_DETAIL_FAQS);
    return { viewSpotDetailFaqs };
}
